import { render, staticRenderFns } from "./DropSettings.vue?vue&type=template&id=81ba354a&scoped=true&"
import script from "./DropSettings.vue?vue&type=script&lang=js&"
export * from "./DropSettings.vue?vue&type=script&lang=js&"
import style0 from "./DropSettings.vue?vue&type=style&index=0&id=81ba354a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ba354a",
  null
  
)

export default component.exports